<template>

  <form v-if="agent" class="form" v-on:submit.prevent="updateAgent">

    <h1>Agent: {{ agent.company_name }}</h1>

    <div class="box">

      <Errors/>

      <AgentFields/>

      <div class="form-wrap form-submit">
        <div class="mt-1" v-if="this.getLoadStatus">
          <button type="submit" class="button" disabled><span>Updating...</span></button>
        </div>
        <div class="mt-1" v-else>
          <button type="submit" class="button" v-if="userRole ==1"><span>Update agent</span></button>
        </div>
      </div>

    </div>

    <template v-if="agent.bookings && agent.bookings.length > 0">
      <h2>Bookings for {{agent.name}}</h2>
      <div class="box">
        <table class="table" cellspacing="0" cellpadding="0" v-if="agent.bookings">
          <thead v-if="agent.bookings.length > 0">
            <tr>
              <th>Booking ref</th>
              <th>Customer</th>
              <th>Date booked</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="booking of agent.bookings" :key="booking.id">
              <td><router-link :to="{ name: 'booking-edit', params: { id: booking.id }}">{{ booking.booking_ref || booking.old_booking_id }}</router-link></td>
              <td v-if="booking.customer">
                <router-link :to="{ name: 'customer-edit', params: { id: booking.customer.id }}">{{ booking.customer.first_name }} {{ booking.customer.last_name }}</router-link>
              </td>
              <td v-else-if="booking.old_customer">
                <router-link :to="{ name: 'customer-edit', params: { id: booking.old_customer.id }}">{{ booking.old_customer.first_name }} {{ booking.old_customer.last_name }}</router-link>
              <td v-else>-</td>
              <td>{{ booking.created_at | formatDate }}</td>
              <td class="table-action">
                <router-link :to="{ name: 'booking-edit', params: { id: booking.id }}" class="icon icon--more">View</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

  </form>

</template>

<script>
import AgentFields from '@/components/AgentFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AgentEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      agent: null,
      errors: null
    }
  },
  components: {
    AgentFields,
    Errors
  },
  created () {
    this.getAgent()
  },
  watch: {
    '$route': 'getAgent'
  },
  methods: {
    getAgent () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'agents/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.agent = response.data[0]
        if(this.agent.old_bookings.length > 0) this.agent.bookings = this.agent.bookings.concat(this.agent.old_bookings)
        this.$store.dispatch('setLoadStatus')
      })
    },
    updateAgent () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'agents/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.agent),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.agent.password = null
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    viewBooking(data) {
      this.$router.push({ name: 'booking-edit', params: { id: data }})
    }
  }
}
</script>
